<script setup>
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import SettingDetails from "@/components/approval-center/settings/SettingDetails.vue";
import AutoApprovals from "@/components/approval-center/settings/AutoApprovals.vue";
import LoadingBlock from "@/components/global-themed/LoadingBlock.vue";
import useApprovalSettings from "@/composables/approval-center/settings/useApprovalSettings";
import WebsiteEmailFrequency from "@/components/approval-center/settings/WebsiteEmailFrequency.vue";
import KitEmailRecipients from "@/components/approval-center/settings/KitEmailRecipients.vue";
import useUser from "@/composables/useUser";

const { settingsQuery, kitEmailRecipientsQuery } = useApprovalSettings();
const { isLoading: isSettingsLoading } = settingsQuery;
const { isLoading: isRecipientsLoading } = kitEmailRecipientsQuery;

const { canManageEmailSettings } = useUser();
</script>

<template>
  <div class="tw-m-auto tw-max-w-default-container">
    <div class="tw-flex tw-flex-col tw-gap-y-8">
      <div class="tw-flex tw-flex-center tw-justify-between">
        <h1 class="tw-font-bold tw-text-4.5xl">
          Approval Center Settings
        </h1>
        <DefaultButton
          variant="primary"
          as="a"
          href="/approval-center"
          class="tw-h-13"
        >
          <svg-vue
            icon="icons/back-arrow"
            class="tw-w-6 tw-h-6 tw-mr-3"
          />
          <span class="tw-font-normal">Back</span>
        </DefaultButton>
      </div>

      <LoadingBlock v-if="isSettingsLoading" />

      <template v-else>
        <SettingDetails />

        <AutoApprovals />

        <WebsiteEmailFrequency v-if="canManageEmailSettings" />

        <KitEmailRecipients v-if="!isRecipientsLoading && canManageEmailSettings" />
      </template>
    </div>
  </div>
</template>


